import { render, staticRenderFns } from "./ManualHomeworkAnswersWidget.vue?vue&type=template&id=aaaa5ec8"
import script from "./ManualHomeworkAnswersWidget.vue?vue&type=script&lang=js"
export * from "./ManualHomeworkAnswersWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aaaa5ec8')) {
      api.createRecord('aaaa5ec8', component.options)
    } else {
      api.reload('aaaa5ec8', component.options)
    }
    module.hot.accept("./ManualHomeworkAnswersWidget.vue?vue&type=template&id=aaaa5ec8", function () {
      api.rerender('aaaa5ec8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/dashboard_widgets/ManualHomeworkAnswersWidget.vue"
export default component.exports